import { memo } from 'react'
import CreativeCardSkeleton from './CreativeCardSkeleton'

/**
 * Grid skeleton loader for the creatives library
 * Shows multiple skeleton cards in the same grid layout
 */
const CreativesGridSkeleton = memo(({ count = 6 }) => {
  return (
    <div className="tw:grid tw:grid-cols-[repeat(auto-fill,minmax(300px,1fr))] tw:gap-5 tw:pb-20">
      {Array.from({ length: count }, (_, index) => (
        <CreativeCardSkeleton key={index} />
      ))}
    </div>
  )
})

CreativesGridSkeleton.displayName = 'CreativesGridSkeleton'

export default CreativesGridSkeleton